export default "__VITE_ASSET__DVHOiotT__"